import { XApp, XDevExtreme } from '@core/utils';

export const configFields = ['raccoon', 'apiUrl'];

export const defaultDataSource = XDevExtreme.createDefaultDataSourceInitializer(
  configFields
);

export default XApp.createAxiosInstance(configFields);
